var React = require('react');

function SocialFb (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("path",{"d":"M0 0h16v16H0z","key":0}),React.createElement("path",{"fill":"#FEFEFE","d":"M7.228 12.057c0 1.056-.006 2.112.005 3.168.002.235-.074.307-.304.303a68.417 68.417 0 0 0-2.2 0c-.226.005-.288-.076-.287-.292.006-2.12 0-4.24.01-6.36 0-.213-.066-.258-.258-.255-.597.009-1.193-.005-1.79.006-.212.005-.278-.07-.275-.28.011-.71.011-1.419 0-2.128-.004-.216.072-.274.28-.269.58.014 1.16-.004 1.74.01.227.005.303-.055.304-.297.002-.796.006-1.595.061-2.39.093-1.298 1.037-2.42 2.304-2.69C7.375.465 7.964.472 8.539.457c.401-.011.803.04 1.206.06.156.008.222.064.22.238-.011.645-.01 1.289-.001 1.934.002.168-.044.219-.217.221-.554.008-1.11.013-1.661.067-.522.049-.812.332-.85 1.047-.03.562 0 1.128-.013 1.692-.005.203.079.245.256.243.717-.006 1.434.004 2.151-.008.188-.002.24.053.214.234-.102.757-.198 1.515-.294 2.275-.021.178-.149.163-.268.164-.596.002-1.193.01-1.79-.003-.209-.004-.272.051-.27.27.012 1.055.006 2.111.006 3.167","key":1})]));
}

SocialFb.displayName = "SocialFb";

SocialFb.defaultProps = {"width":"16","height":"16"};

module.exports = SocialFb;

SocialFb.default = SocialFb;



// WEBPACK FOOTER //
// ./src/images/icons/social-fb.svg